import instance from "../api/api";

const register = async (data) => {
  const response = await instance.post(`/register`, data);
  return response;
};

const login = async (data) => {
  const response = await instance.post(`/login`, data);
  if (response.data.token) {
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("username", response.data.username);
  }
  return response;
};

const logout = async () => {
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  window.location.reload();
};

export { register, login, logout };
